<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          <v-row>
            <!--<v-col cols="2">
             <left-emp-menu></left-emp-menu>
        </v-col>-->
          <v-col>
            <v-row >
            <v-col cols="12">
                <v-list three-line subheader>
                      <v-col class='text-right'>
                      <v-btn color="primary" depressed @click="dialogAdd = true , validate('ADD')">
                        <v-icon left>mdi-text-box-plus</v-icon>
                        เพิ่มประวัติการทำงาน
                      </v-btn>
                      </v-col>

                     <!-- ADD -->
                    <v-dialog v-model="dialogAdd" persistent max-width="80%">
                      <v-card>
                        <v-card-title>
                          <span class="headline">เพิ่มข้อมูล</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                          <v-form
                            ref="form_add"
                            v-model="valid_add"
                            lazy-validation
                          >
                            <v-row>
                              <v-col cols="4">
                                <v-select
                                  :items="dataPosition"
                                  v-model="formAdd.empJobCode"
                                  label="ตำแหน่งงาน*"
                                  :rules="nameRules"
                                  placeholder="Select..."
                                  required
                                  dense
                                ></v-select>
                              </v-col>

                          <v-col cols="4">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formAdd.startDate"
                                  label="วันที่เริ่มทำงาน"
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="formAdd.startDate" no-title scrollable
                              locale="th-th">
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(formAdd.startDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                         <v-col cols="4">
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formAdd.endDate"
                                  label="วันที่สิ้นสุด"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="formAdd.endDate" no-title scrollable
                              locale="th-th">
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu2 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu2.save(formAdd.endDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        <v-col cols="4">
                          <v-select
                            :items="itemStatus"
                            v-model="formAdd.empJobStatus"
                            label="สถานะงาน*"
                            :rules="nameRules"
                            placeholder="Select..."
                            required
                            dense
                        ></v-select>
                          </v-col>

                          <v-col cols="4">
                          <v-select
                            :items="statusPosition"
                            v-model="formAdd.empStatus"
                            label="สถานะพนักงาน*"
                            :rules="nameRules"
                            placeholder="Select..."
                            @change="getDataEmpPosition(formAdd.empStatus)"
                            required
                            dense
                        ></v-select>

                          </v-col>
                          <v-col cols="4">
                          <v-text-field
                              v-model="formUpdate.empNumDay"
                              label="จำนวนวันที่ทำงาน"
                              required
                              readonly
                              dense
                          ></v-text-field>
                          </v-col>
                            </v-row>
                            </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            elevation="2"
                            x-large
                            color="dark darken-1"
                            text
                            @click="dialogAdd = false,clearData()"
                          >
                            <v-icon left> mdi-cancel</v-icon>
                            ปิด
                          </v-btn>
                          <v-btn
                            elevation="2"
                            x-large
                            color="success"
                            text
                            :disabled="!valid_add"
                            @click="addData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            เพิ่ม
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- end add -->

                    <!-- edit -->
                    <v-dialog v-model="dialogEdit" persistent max-width="80%">
                      <v-card>
                        <v-card-title>
                          <span class="headline">แก้ไขข้อมูล</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                          <v-form
                            ref="form_update"
                            v-model="valid_update"
                            lazy-validation
                          >
                            <v-row>
                              <v-col cols="4">
                                <v-select
                                  :items="dataPosition"
                                  v-model="formUpdate.empJobCode"
                                  label="ตำแหน่งงาน*"
                                  :rules="nameRules"
                                  placeholder="Select..."
                                  required
                                  dense
                                ></v-select>
                              </v-col>

                          <v-col cols="4">
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formUpdate.startDate"
                                  label="วันที่เริ่มทำงาน"
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="formUpdate.startDate" no-title scrollable
                              locale="th-th">
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu3 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu3.save(formUpdate.startDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                         <v-col cols="4">
                            <v-menu
                              ref="menu4"
                              v-model="menu4"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formUpdate.endDate"
                                  label="วันที่สิ้นสุด"
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="formUpdate.endDate" no-title scrollable
                              locale="th-th">
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu4 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu4.save(formUpdate.endDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        <v-col cols="4">
                          <v-select
                            :items="itemStatus"
                            v-model="formUpdate.empJobStatus"
                            label="สถานะงาน*"
                            :rules="nameRules"
                            placeholder="Select..."
                            required
                            dense
                        ></v-select>
                          </v-col>

                          <v-col cols="4">
                          <v-select
                            :items="statusPosition"
                            v-model="formUpdate.empStatus"
                            label="สถานะพนักงาน*"
                            :rules="nameRules"
                            placeholder="Select..."
                            required
                            dense
                        ></v-select>

                          </v-col>
                          <v-col cols="4">
                          <v-text-field
                              v-model="formUpdate.empNumDay"
                              :rules="nameRules"
                              label="จำนวนวันที่ทำงาน"
                              required
                              dense
                          ></v-text-field>
                          </v-col>
                            </v-row>
                          </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            elevation="2"
                            x-large
                            color="blue darken-1"
                            text
                            @click="dialogEdit = false"
                          >
                            <v-icon left> mdi-cancel</v-icon>
                            ปิด
                          </v-btn>
                          <v-btn
                            elevation="2"
                            x-large
                            color="success"
                            text
                            :disabled="!valid_update"
                            @click="editData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            แก้ไข
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- end edit -->

                    <v-card>
                      <v-card-text>
                      <v-form>
                      <v-container class="py-0">
                        <v-row>
                          <!-- data table -->
                            <v-col cols="12">
                              <v-card elevation="7" v-if="dataReady">
                                <v-card-text>
                                  <v-data-table
                                    class="table-striped table-bordered"
                                    :headers="columns"
                                    :items="dataItem"
                                    :items-per-page="10"
                                  >
                                    <template v-slot:[`item.CREATE_DATE`]="{ item }">
                                        {{ format_date(item.CREATE_DATE) }}
                                    </template>
                                    <template v-slot:[`item.LAST_DATE`]="{ item }">
                                        {{ format_date(item.LAST_DATE) }}
                                    </template>
                                    <template v-slot:[`item.action`]="{ item }">
                                      <v-btn
                                        color="question"
                                        fab
                                        small
                                        @click.stop="(dialogEdit = true), getDataById(item), validate('UPDATE')"
                                      >
                                        <v-icon dark> mdi-tools </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-card-text>
                              </v-card>
                              <div v-if="!dataReady" class="text-center">
                                <v-progress-circular
                                  indeterminate
                                  color="primary"
                                ></v-progress-circular>
                              </div>
                            </v-col>
                            <!-- end data table -->

                        </v-row>
                      </v-container>
                      </v-form>
                    </v-card-text>
                    <v-col class='text-right'>
                <v-btn
                  color='success'
                  class="mr-0"
                  @click="pushBack"
                >
                  ย้อนกลับ
                </v-btn>
                <v-btn
                  color='success'
                  class="mr-0"
                  @click="pushNext"
                >
                  ต่อไป
                </v-btn>
              </v-col>
                  </v-card>
                </v-list>
            </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import EmpMenu from './EmployeeMenu.vue'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    'left-emp-menu': EmpMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/emp_job_experience/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      valid_add: true,
      valid_update: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialogAdd: false,
      dialogEdit: false,
      session: this.$session.getAll(),
      itemStatus: ['ดำเนินการ', 'สิ้นสุดงาน'],

      formAdd: {
        empCode: '',
        empJobCode: '',
        startDate: '',
        endDate: '',
        empJobStatus: '',
        empStatus: '',
        ExpireDateDiff: ''
      },
      formUpdate: {
        empCode: this.$session.getAll().data.empCode,
        empJobCode: '',
        startDate: '',
        endDate: '',
        empJobStatus: '',
        empStatus: '',
        ExpireDateDiff: ''
      },
      formUpdateItem: {
        empCode: '',
        empJobCode: '',
        startDate: '',
        endDate: '',
        empJobStatus: '',
        empStatus: '',
        ExpireDateDiff: ''

      },
      nameRules: [
        (v) => !!v || 'Input is required'
      ],
      columns: [
        { text: 'ตำแหน่งงาน', value: 'empJobCode', align: 'center' },
        { text: 'วันที่เริ่มทำงาน', value: 'startDate', align: 'center' },
        { text: 'วันที่สิ้นสุด', value: 'endDate', align: 'center' },
        { text: 'สถานะงาน', value: 'empJobStatus', align: 'center' },
        { text: 'จำนวนวันที่ทำงาน', value: 'ExpireDateDiff', align: 'center' },
        { text: 'สถานะพนักงาน', value: 'empStatus', align: 'center' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],

      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      dataPosition: [],
      statusPosition: []
    }
  },
  async mounted () {
    // await this.getGetTokenForEmployee()
    console.log(this.$session.getAll().data)
    this.dataReady = false
    // Get Data
    await this.getDataById()
    await this.getDataPosition()
    await this.getDataEmpPosition()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataById (item) {
      this.dataReady = false
      await this.getDataByIdSubmit(
        this.DNS_IP,
        this.path,
        this.$session.getAll().data.empCode
      )
    },
    async getDataByIdSubmit (DNS_IP, PATH, id) {
      this.dataItem = []
      this.PK = id
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "getEmpCode?empCode" + "=" + id,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('get id : ', response)
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            delete this.formUpdate['empJobId']
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['RECORD_STATUS']
            this.empCode = this.formUpdate.empCode
            this.getData(this.formUpdate.empCode)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getData (DT) {
      // this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/emp_job_experience/" + "getEmpCode?empCode=" + DT,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('empJobId', response.data)
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async editData () {
      // Config User ทำรายการล่าสุด
      this.formUpdateItem.LAST_USER = this.$session.getAll().data.userName
      // End Config User ทำรายการล่าสุด

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }
      console.log('this.formUpdateItem', this.formUpdateItem)

      // Debug
      console.log('EDIT PK : ', this.PK)
      console.log('formUpdateItem', JSON.stringify(this.formUpdateItem))
      // End Debug
      // สำหรับ แก้ไขข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนแก้ไขล่าสุด
      //
      this.dataReady = false
      this.submitEdit(
        this.DNS_IP,
        this.path,
        this.PK,
        this.formUpdateItem
      )
    },
    async submitEdit (DNS_IP, PATH, ID, DT) {
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let rs = this.dataItem
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            let ds = {
              empJobCode: d.empJobCode,
              startDate: d.startDate,
              endDate: d.endDate,
              empJobStatus: d.empJobStatus,
              empStatus: d.empStatus,
              ExpireDateDiff: d.ExpireDateDiff
            }
            await axios
              .post(
              // eslint-disable-next-line quotes
                this.DNS_IP + "/emp_job_experience/" + "edit/" + d.empJobId,
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async (response) => {
              // Debug response
                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogEdit = false
                // Load Data
                await this.getDataById()
              })
            // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal55555 : ', error)
              })
          }
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async getDataPosition () {
      // Clear Data ทุกครั้ง
      this.dataPosition = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masDepartmentName
            s.text = d.masDepartmentName
            d = s
            this.dataPosition.push(d)
          }
          console.log('getDataPosition : ', this.dataPosition)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataEmpPosition () {
      // Clear Data ทุกครั้ง
      this.statusPosition = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/pos_position_type/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.positionTypeName
            s.text = d.positionTypeName
            d = s
            this.statusPosition.push(d)
          }
          console.log('getDataPosition : ', this.statusPosition)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async addData () {
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = this.$session.getAll().data.empCode
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

      console.log('form', JSON.stringify(this.formAdd))

      this.dataReady = false
      this.addDataSubmit()
    },
    async addDataSubmit () {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/emp_job_experience/" + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + "/emp_job_experience/" + "add"', response)
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogAdd = false
                this.dataReady = true
                this.clearData()
                this.getDataById()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        console.log('Key', key)
        console.log('Value', this.formAdd)

        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    pushNext () {
      this.$router.push('/HRM/Employee/EmployeeUploadFile?Code=' + this.$session.getAll().data.empCode + '&access=' + this.$route.query.access + '&roll=' + this.$route.query.roll)
    },
    pushBack () {
      this.$router.push('/HRM/Employee/EmployeeComputerSkill?Code=' + this.$session.getAll().data.empCode + '&access=' + this.$route.query.access + '&roll=' + this.$route.query.roll)
    }
  }
}
</script>
<style scope>
.scroll {
   overflow-y: scroll
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeePositionTransfer.vue